module.exports = __webpack_public_path__ + "static/media/sebaceousCells.f351961f.jpg";